import useTranslation from '../../hooks/useTranslation';
import { formatTotalApplied } from '../../utils/formatTotalApplied';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TankMixSection: FunctionComponent<Props> = ({ mixRecipe, testId = TEST_ID, totalAcres }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.tankMixSection} testId={testId}>
            <Wrapper className={styles.sectionHeader}>{translations.TANK_MIX}</Wrapper>

            <Grid className={styles.grid}>
                <Wrapper className={styles.headerCell}>{translations.ORDER_COLUMN}</Wrapper>

                <Wrapper className={styles.headerCell}>{translations.PRODUCT_COLUMN}</Wrapper>

                <Wrapper className={styles.headerCell}>{translations.EPA_COLUMN}</Wrapper>

                <Wrapper className={styles.headerCell}>{translations.RATE_COLUMN}</Wrapper>

                <Wrapper className={styles.headerCell}>{translations.TOTAL_APPLIED_COLUMN}</Wrapper>

                {mixRecipe.products.map((product, index) => (
                    <Wrapper className={styles.rowContents} key={product.productId}>
                        <Wrapper className={styles.bodyCell}>{`${index + 1}`}</Wrapper>

                        <Wrapper className={styles.bodyCell}>{product.productName}</Wrapper>

                        <Wrapper className={styles.bodyCell}>{product.epaRegNumber}</Wrapper>

                        <Wrapper className={styles.bodyCell}>
                            {`${product.rate} ${product.rateUnit}`}
                        </Wrapper>

                        <Wrapper className={styles.bodyCell}>
                            {formatTotalApplied({
                                rate: product.rate,
                                rateUnit: product.rateUnit,
                                totalAcres
                            })}
                        </Wrapper>
                    </Wrapper>
                ))}
            </Grid>
        </VerticalContainer>
    );
};

export default TankMixSection;
